// extracted by mini-css-extract-plugin
module.exports =  {"container":"_02712f2b3b--container--i5GK0","aside":"_02712f2b3b--aside--qIRjU","close":"_02712f2b3b--close--Cs24z"};